export enum ETaxRuleType {
  AnnualPayment = 0,
  LumpSumPayout = 1,
}
